export const FILE_SOURCE = {
  community: 'community',
  settings: 'settings',
} as const

export type FileSource = (typeof FILE_SOURCE)[keyof typeof FILE_SOURCE]

export const DEFAULT_FILE_SOURCE: FileSource = FILE_SOURCE.community
